export interface FindPlaybackParams {
  date?: string;
  vehicle_id?: string;
  partner_id?: string;
  'donation_id[]'?: string[];
}
